import styles from '../../assets/styles/LandingPage/Article.module.scss';
import React from 'react';
import Header3 from './Header3';
import Footer from './Footer';
import { MimaButton, MimaText } from '../../components';
import img_everything2 from '../../assets/img/img_everything2.png';
import PlayStoreIcon from '../../assets/img/playstore.png';
import AppleStoreIcon from '../../assets/img/apple.png';
import { useNavigate } from 'react-router';
import constant from '../../utils/constant';
import { otherArticles } from '../../utils/utils';
import { Link } from 'react-router-dom';



const Article3 = () => {

    const appleIcon = <img src={AppleStoreIcon} className={styles.btn__icon} alt="Apple icon" />;

    const playIcon = <img src={PlayStoreIcon} className={styles.btn__icon} alt="Playstore icon" />;
    
    const navigate = useNavigate();

    const switchToSignup = () => {
        navigate(constant.Routes.SignUp);
    };

    const otherArticlesfiltered = otherArticles.filter((item, index) => index !== 2);

    return (
        <>
            <Header3 />
            <div className={styles.container}>
                <div className={styles.container_title}>
                    <MimaText variant="h3" align="center" color="var(--color-primary)">
                        Everything You Need to Know About <br />Mima Business Pay Bills Feature
                    </MimaText>
                </div>
                <img
                    src={img_everything2}
                    alt='Article'
                    className={styles.container_img}
                />
                <MimaText variant="body2" ml={1} mr={1} mb={2}>
                    In today’s fast paced world, individuals are looking for better and faster ways to save time and make their lives more easier and convenient. One of the most time consuming and frustrating tasks is paying bills. Whether it is electricity bills, cable tv, phone bills, paying bills as a whole can be a hassle. With the birth of Mima Business online payment system, paying bills has become much easier and more convenient. In this blog post, we will explore the benefits of paying bills online and how you can get started with the pay-bills feature.
                </MimaText>
                <MimaText variant="bodyBold" ml={1} mr={1} mb={2} align="left">
                    What are the benefits of the Pay-Bill feature?
                </MimaText>
                <ul className={styles.container_list}>
                    <li><b> Convenience:</b> One of the biggest benefits of the Pay-Bill feature is the convenience it offers. You can literally pay your bills from anywhere, at any time, as long as you have an internet connection. You do not have to worry about waiting in long lines to purchase airtime, or finding time to visit a POS terminal or the power company to pay your electricity bills. </li>
                    <li><b>Time-saving:</b> With Mima Business online payment, you can pay your bills with just a few clicks thus reducing a long purchase process.  </li>
                    <li><b>Cost effective:</b> The Mima Business online bill payment does not charge excessively nor does it have hidden charges. You pay exactly for what you buy or even lesser. </li>
                    <li><b>Record Keeping:</b> Our online payment system helps keep records of all your payments, so you do not have to worry about losing your receipts. You can also access all your payment history anytime, any day which can be useful in tracking your expenses. </li>
                    <li><b>Secured:</b> Mima Business payment systems are highly secured and our data encryption standard meets global data security requirements to protect your personal and financial information.</li>
                </ul>

                <MimaText variant="bodyBold" ml={1} mr={1} mb={2} align="left">
                    How to Get Started With Mima Pay Bills Feature Sign up for an account:
                </MimaText>
                <ul className={styles.container_list}>
                    <li>The first step to using the Pay bills feature is to sign up for an account on the Mima Business app. You’ll need to provide some basic information such as your full name, business email, business name, phone number, desired password, and a referral code (if any). Once you’ve signed up for an account, you can now transact with the pay bills features. This includes your airtime/data, cable tv, utilities and any other bills you need to pay regularly. </li>
                    <li>To view: You can view the pay bill feature by logging into your mima business account. From the dashboard, click on the pay bills icon to view all available bills. </li>
                </ul>
                <MimaText variant="body2" ml={1} mr={1} mb={2} align="left">Paying bills online is a convenient, time-saving, and cost effective way to manage your finances. With Mima’s pay bill feature, you can easily manage and pay all your bills on one platform. </MimaText>
                <MimaText variant="body2" ml={1} mr={1} mb={2} align="left"> <span style={{ fontWeight: "700", cursor: "pointer", color: "var(--color-primary)" }} onClick={switchToSignup}>CLICK HERE</span> to sign up today and start enjoying the benefits of Mima Business.</MimaText>

                <div className={styles.slide__text_btn}>
                    <a
                        href="https://play.google.com/store/apps/details?id=com.mima.mima"
                        style={{ textDecoration: 'none' }}>
                        <MimaButton
                            title="Get app on Android"
                            variant="outlined"
                            icon={playIcon}
                            width={30}
                        />
                    </a>

                    <a
                        href="https://apps.apple.com/us/app/mima-business/id6444887331"
                        style={{ textDecoration: 'none' }}>
                        <MimaButton
                            title="Get app on iPhone"
                            variant="outlined"
                            icon={appleIcon}
                            width={30}
                        />
                    </a>
                </div>

                <MimaText mt={2} mb={2} variant="smallBold">Related Articles</MimaText>
                <div className={styles.related}>
                    {otherArticlesfiltered.map((x, i) => (
                        <Link key={i} to={x.link} className={styles.related__card}>
                            <img
                                src={x.src}
                                alt={x.title}
                            />
                            <MimaText variant="bodyBold" mt={2}>{x.title}</MimaText>
                            <MimaText variant="smallBold" color="var(--color-primary)" mt={2}>Click Here</MimaText>
                        </Link>
                    ))}
                </div>

            </div>
            <Footer />
        </>
    )
}
export default Article3;